module.exports = __webpack_public_path__ + "img/o_2.adea0701.png";